import { useEffect } from "react";
import { Suspense, lazy } from "react";

import {
  initializeApiErrorHandler,
  initializeContactUsHandler,
  initializeMyProfileHandler,
  initializeMyMortgageHandler,
  initializeMyDocumentsHandler,
  initializeDownloadDocumentsHandler,
  initializeValidateUserHandler,
  initializeYourToDoListsHandler,
  initializeYourPreferencesHandler,
  initializeSaveYourPreferencesHandler,
  initializeYourToDoListsPreferencesHandler,
  initializeHomePageHandler,
  initializeViewDocumentsHandler,
} from "../services/apiHandler";
import ErrorLayout from "../components/error-layout";
import GlobalErrorComponent from "../components/Error-Components/global-error-component";
import AppLayout from "../components/app-layout";

import { Routes, Route } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Path } from "../utils/constant";
import ProtectedRoute from "../auth/protectedRoute";
import { useGlobalError } from "../utils/errorContext";
import SessionManager from "../auth/sessionManager";
import ScrollToTop from "../utils/scrollToTop";

const Homepage = lazy(() => import("../pages/HomePage/HomePage"));
const ContactUs = lazy(() => import("../pages/ContactUs"));
const MyMortgage = lazy(() => import("../pages/MyMortgage"));
const MyDocuments = lazy(() => import("../pages/MyDocuments"));
const MyProfile = lazy(() => import("../pages/MyProfile"));

const AppRouting = () => {
  const { error, showError } = useGlobalError();
  const { t } = useTranslation();
  //const location = useLocation();

  useEffect(() => {
    const cleanupApiError = initializeApiErrorHandler(showError, t);
    const cleanupContactUs = initializeContactUsHandler();
    const cleanupMyProfile = initializeMyProfileHandler();
    const cleanupHomePage = initializeHomePageHandler();
    const cleanupYourToDoLists = initializeYourToDoListsHandler();
    const cleanupYourToDoListsPreferences =
      initializeYourToDoListsPreferencesHandler();
    const cleanupYourPreferences = initializeYourPreferencesHandler();
    const cleanupMyMortgage = initializeMyMortgageHandler();
    const cleanupMyDocuments = initializeMyDocumentsHandler();
    const cleanupDownloadDocuments = initializeDownloadDocumentsHandler();
    const cleanupValidateUser = initializeValidateUserHandler();
    const cleanupSaveYourPreferences = initializeSaveYourPreferencesHandler();
    const cleanupViewDocuments = initializeViewDocumentsHandler();

    return () => {
      cleanupApiError?.();
      cleanupContactUs?.();
      cleanupMyProfile?.();
      cleanupMyMortgage?.();
      cleanupMyDocuments?.();
      cleanupDownloadDocuments?.();
      cleanupValidateUser?.();
      cleanupYourToDoLists?.();
      cleanupYourPreferences?.();
      cleanupSaveYourPreferences?.();
      cleanupYourToDoListsPreferences?.();
      cleanupHomePage?.();
      cleanupViewDocuments?.();
    };
  }, [showError, t]);

  // if (error) {
  //   return (
  //     <ErrorLayout isError>
  //       <GlobalErrorComponent />
  //     </ErrorLayout>
  //   );
  // }
  console.log("AppRouting Rendered with error:", error);
  return (
    <>
      {error && (
        <ErrorLayout isError>
          <GlobalErrorComponent />
        </ErrorLayout>
      )}

      <div style={{ display: error ? "none" : "block" }}>
        <Suspense fallback={<div>Loading...</div>}>
          <SessionManager />
          <ScrollToTop />

          <Routes>
            <Route>
              <Route
                path={Path.HOME}
                element={
                  <ProtectedRoute>
                    <AppLayout>
                      <Homepage />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
              <Route
                path={Path.MORTGAGE}
                element={
                  <ProtectedRoute>
                    <AppLayout>
                      <MyMortgage />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
              <Route
                path={Path.DOCUMENTS}
                element={
                  <ProtectedRoute>
                    <AppLayout>
                      <MyDocuments />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
              <Route
                path={Path.PROFILE}
                element={
                  <ProtectedRoute>
                    <AppLayout>
                      <MyProfile />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
              <Route
                path={Path.CONTACT_US}
                element={
                  <ProtectedRoute>
                    <AppLayout>
                      <ContactUs />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
            </Route>
          </Routes>
        </Suspense>
      </div>
    </>
  );
};

export default AppRouting;
